import { useState, useContext, useEffect } from 'react';
import { useSnapshot } from 'valtio';
import { MiViewScreen } from 'basics/enums/miview.enums';
import useGetAllVeevaVaultDocument from 'basics/graphql/queries/getAllVeevaVaultDocument';
import useGetAllVeevaVaultIVADocument from 'basics/graphql/queries/getAllVeevaVaultIVADocument';
import { CepStateType } from 'basics/types/maya.types';
import { ProductsContext } from 'contexts/products';
import {
  VeevaVaultIvaDocumentFilter,
  VeevaVaultDocumentLimit,
  VeevaVaultDocumentFilter,
  CustomerInitiative,
} from 'generated/maya.types';
import cepState from 'states/cep.states';

const useMiViewScreenLayout = () => {
  const [firstScreen, setFirstScreen] = useState(MiViewScreen.cepTargets);
  const [secondScreen, setSecondScreen] = useState(MiViewScreen.cepActivities);
  const [fullScreenFirstScreen, setFullScreenFirstScreen] = useState<boolean>(false);
  const [fullScreenSecondScreen, setFullScreenSecondScreen] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);

  const cepStateValue = useSnapshot(cepState) as CepStateType;
  const { productList } = useContext(ProductsContext);
  const currentProduct = productList?.find((product) => product.productExternalID === cepStateValue?.cep?.product);
  const customerInitiative = cepStateValue.cep?.customerInitiative as CustomerInitiative;
  const { country } = customerInitiative;

  const vaultIVADocumentFilter: VeevaVaultIvaDocumentFilter = {
    country,
    product: currentProduct?.productID,
  };

  const vaultDocumentLimit: VeevaVaultDocumentLimit = {
    limit: 5000,
  };

  const {
    data: IVADocuments,
    loading: allVeevaVaultIVADocumentsLoading,
  } = useGetAllVeevaVaultIVADocument(vaultDocumentLimit, vaultIVADocumentFilter);

  const vaultDocumentFilter: VeevaVaultDocumentFilter = {
    country,
    product: currentProduct?.productID,
  };

  const {
    data: AEDocuments,
    loading: allVeevaVaultDocumentsLoading,
  } = useGetAllVeevaVaultDocument(vaultDocumentLimit, vaultDocumentFilter);

  useEffect(() => {
    setLoading(allVeevaVaultIVADocumentsLoading || allVeevaVaultDocumentsLoading);
  }, [allVeevaVaultIVADocumentsLoading, allVeevaVaultDocumentsLoading]);

  return {
    firstScreen,
    setFirstScreen,
    secondScreen,
    setSecondScreen,
    fullScreenFirstScreen,
    setFullScreenFirstScreen,
    fullScreenSecondScreen,
    setFullScreenSecondScreen,
    IVADocuments,
    AEDocuments,
    loading,
  };
};

export default useMiViewScreenLayout;
